function inputTel(id) {
  if (id.length) {
    id.mask('+7 (999) 999-99-99');
  }
}

function inputTelModalReg(id) {
  if (id.length) {
    id.mask('+7 (999) 999-99-99', {completed: showSmsConfirm});
  }
}

function inputPassportSeries(id) {
    if (id.length) {
        id.mask('9999');
    }
}

function inputPassportNumber(id) {
    if (id.length) {
        id.mask('999999');
    }
}